import { render, staticRenderFns } from "./CombinedChangesSaver.Vue?vue&type=template&id=46b7a5fc"
import script from "./CombinedChangesSaver.Vue?vue&type=script&lang=js"
export * from "./CombinedChangesSaver.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/CombinedChangesSaver.Vue
// module id = 208
// module chunks = 0